var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-wait',{attrs:{"for":"loadMessages"}},[_c('template',{slot:"waiting"},[_c('p',{staticClass:"eh-secondary-text text-center mt-3"},[_vm._v("\n      Loading messages ...\n    ")])]),_vm._v(" "),_c('div',{staticClass:"e-chat"},[_c('e-chat')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28dc2e22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/chat/chat.vue
// module id = XEzv
// module chunks = 22